"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTicket = createTicket;
exports.createTicketWithAssociations = createTicketWithAssociations;
exports.updateElasticSearch = updateElasticSearch;
exports.revertMove = revertMove;
exports.updateTickets = updateTickets;
exports.updateTicketProperties = updateTicketProperties;
exports.deleteTicket = deleteTicket;
exports.refresh = refresh;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _q = _interopRequireDefault(require("q"));

var _immutable = require("immutable");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _Dispatch = require("crm_data/dispatch/Dispatch");

var TicketsAPI = _interopRequireWildcard(require("crm_data/tickets/api/TicketsAPI"));

var ImmutableModel = _interopRequireWildcard(require("customer-data-objects/model/ImmutableModel"));

var _AssociationTypes = require("crm_data/associations/AssociationTypes");

var makeAssociationKey = function makeAssociationKey(id, associationType) {
  return (0, _immutable.Map)({
    objectId: id,
    objectType: _ObjectTypes.TICKET,
    associationType: associationType
  });
};

function createTicket(ticketRecord) {
  var getPropertiesList = function getPropertiesList(objectRecord) {
    return objectRecord.get('properties').reduce(function (list, _ref, name) {
      var value = _ref.value,
          sourceId = _ref.sourceId,
          source = _ref.source;
      return list.push({
        value: value,
        name: name,
        sourceId: sourceId,
        source: source
      });
    }, (0, _immutable.List)());
  };

  var apiPayload = {
    associations: {},
    portalId: _hubspot.default.get(),
    properties: getPropertiesList(ticketRecord)
  };
  (0, _Dispatch.dispatchImmediate)(_ActionTypes.TICKETS_CREATE_QUEUED);
  return TicketsAPI.createTicket(apiPayload).then(function (ticket) {
    (0, _Dispatch.dispatchQueue)(_ActionTypes.TICKETS_CREATE_SUCCEEDED, ticket);
    return ticket;
  }).catch(function (_) {
    return (0, _Dispatch.dispatchQueue)(_ActionTypes.TICKETS_CREATE_FAILED, _);
  });
}

function createTicketWithAssociations(ticketRecord, requestedAssociatedObjects) {
  var getPropertiesList = function getPropertiesList(objectRecord) {
    return objectRecord.get('properties').reduce(function (list, _ref2, name) {
      var value = _ref2.value,
          sourceId = _ref2.sourceId,
          source = _ref2.source;
      return list.push({
        value: value,
        name: name,
        sourceId: sourceId,
        source: source
      });
    }, (0, _immutable.List)());
  };

  var propertyValues = getPropertiesList(ticketRecord);
  (0, _Dispatch.dispatchImmediate)(_ActionTypes.TICKETS_CREATE_QUEUED);
  return TicketsAPI.createTicketWithAssociations({
    propertyValues: propertyValues,
    requestedAssociatedObjects: requestedAssociatedObjects
  }).then(function (ticket) {
    (0, _Dispatch.dispatchQueue)(_ActionTypes.TICKETS_CREATE_SUCCEEDED, ticket);
    requestedAssociatedObjects.forEach(function (association) {
      (0, _Dispatch.dispatchQueue)(_ActionTypes.OBJECT_ASSOCIATION_SUCCEEDED, {
        objectId: association.objectId,
        associationsAdded: [ImmutableModel.getId(ticket)],
        fromObjectType: association.objectType,
        toObjectType: _ObjectTypes.TICKET
      });
    });
    return ticket;
  }).catch(function (error) {
    (0, _Dispatch.dispatchQueue)(_ActionTypes.TICKETS_CREATE_FAILED, error);
    throw error;
  });
}

function updateElasticSearch(ticket, searchQuery, searchResults) {
  var ticketId = ImmutableModel.getId(ticket);
  var optimisticResults = searchResults.update('_results', function () {
    var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.List)();
    return results.push(ticketId);
  }).update('results', function () {
    var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.List)();
    return results.push(ticketId);
  }).update('total', function () {
    var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return total + 1;
  });
  (0, _Dispatch.dispatchQueue)(_ActionTypes.TICKETS_UPDATED, (0, _immutable.Map)((0, _defineProperty2.default)({}, ticketId, ticket)));
  (0, _Dispatch.dispatchQueue)(_ActionTypes.ES_DATA_UPDATED, {
    objectType: _ObjectTypes.TICKET,
    searchQuery: searchQuery,
    results: optimisticResults
  });
}

function revertMove(ticketId) {
  return (0, _Dispatch.dispatchImmediate)(_ActionTypes.TICKET_STAGE_CHANGE_REVERT, ticketId);
}

function updateTickets(tickets) {
  (0, _invariant.default)(_immutable.Map.isMap(tickets), 'TicketsActions: expected tickets to be a Map but got `%s`', tickets);
  return (0, _Dispatch.dispatchImmediate)(_ActionTypes.TICKETS_UPDATED, tickets);
}

function updateTicketProperties(ticket, nextProperties, options) {
  if (options == null) {
    options = {};
  }

  var ticketActionPayload = {
    id: "" + ImmutableModel.getId(ticket),
    nextProperties: nextProperties,
    properties: nextProperties.map(function (_, name) {
      return ImmutableModel.getProperty(ticket, name);
    }),
    options: options
  };

  if (nextProperties.has('hs_pipeline_stage') && !options.updatedValues) {
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.TICKET_STAGE_CHANGE, ticketActionPayload);
    return _q.default.Promise.resolve();
  }

  (0, _Dispatch.dispatchImmediate)(_ActionTypes.TICKETS_UPDATE_STARTED, ticketActionPayload);
  return TicketsAPI.updateTicketProperties(ticket, nextProperties).then(function (nextTicket) {
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.TICKETS_UPDATE_SUCCEEDED, {
      id: "" + ImmutableModel.getId(nextTicket),
      nextProperties: nextProperties
    });
  }).catch(function (error) {
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.TICKETS_UPDATE_FAILED, (0, _extends2.default)({}, ticketActionPayload, {
      error: error
    }));
    throw error;
  });
}

function deleteTicket(ticketId, callback) {
  return TicketsAPI.deleteTicket(ticketId).then(function () {
    setTimeout(function () {
      (0, _Dispatch.dispatchImmediate)(_ActionTypes.TICKETS_UPDATED, (0, _immutable.Map)().set("" + ticketId, null));
    }, 0);
    return typeof callback === 'function' ? callback() : undefined;
  });
}

function refresh(ids) {
  (0, _Dispatch.dispatchQueue)(_ActionTypes.TICKETS_REFRESH_QUEUED, (0, _immutable.Set)(ids));
  (0, _Dispatch.dispatchQueue)(_ActionTypes.ASSOCIATIONS_REFRESH_QUEUED, (0, _immutable.Set)([makeAssociationKey(ids[0], _AssociationTypes.TICKET_TO_COMPANY), makeAssociationKey(ids[0], _AssociationTypes.TICKET_TO_CONTACT), makeAssociationKey(ids[0], _AssociationTypes.TICKET_TO_DEAL)]));
}